import script from "./SkeletonHomepageMyVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonHomepageMyVideos.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonHomepageMyVideos.vue?vue&type=style&index=0&id=9ac337d2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lms-v3-backend/lms-v3-backend/.vapor/build/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ac337d2"]])

export default __exports__